
import $ from 'jquery';
import View from 'view/base';
import Sortable from 'sortablejs';
import Modal from 'root/module/modal';
import View_Question_Settings from 'view/survey_designer/question_settings';
import View_Question_Select from 'view/survey_designer/question_select';

export default View.extend({
    selected_question: null,

    views: {
        question_settings: {},
        question_add: {}
    },

    events: {
        'click .question-add'    : 'onQuestionAdd',
        'click .question-header' : 'onSelectQuestion',
        'click .delete'          : 'onDelete',
        'click .duplicate'       : 'onDuplicate',
        'click .change'          : 'onChange',
        'mouseleave'             : 'onMouseLeave'
    },

    dom_handlers: {
        onQuestionAdd: function(e) {
            this.$el.find('.region-questions-add').toggle();

            if (this.$el.find('.region-questions-add').is(':visible')) {
                // set dropdown position
                var top = $(e.currentTarget).position().top;

                this.$el.find('.region-questions-add').css({
                    top: Math.max(-70, top - this.$el.find('.region-questions-add').height() + $(e.currentTarget).height())
                });
            }
        },

        onSelectQuestion: function(e) {
            if ($(e.target).hasClass('stop-propagation')) {
                return;
            }

            var question_el = $(e.currentTarget).parents('.question:first');

            if (question_el.hasClass('active')) {
                question_el.removeClass('active');

                return;
            }

            // get question id
            var question_key = question_el.data('key');
            // get question model from collection
            this.selected_question = this.collection.findWhere({question_key: question_key});

            // set selected question
            this.trigger('Question:Select', this.selected_question);

            this.$el.find('.question').removeClass('active');
            question_el.addClass('active');

            // settings view
            this.buildSettingView();
        },

        onDelete: function(e) {
            const delete_question_key = $(e.currentTarget).closest('.question').data('key');

            const delete_question = this.collection.findWhere({question_key: delete_question_key});

            if (!delete_question) {
                return;
            }

            var desc = '<p>Are you sure you want to delete the selected question?</p>';
            if (delete_question.get('question_type') === 'welcome') {
                desc = '<p>Are you sure you want to delete the Intro?</p>';
            }

            Modal.confirm(desc, () => {
                this.collection.remove(delete_question);
            }, undefined, 'Yes, delete');
        },

        onDuplicate: function(e) {
            // find current hovered question id
            var question_key = this.$el.find('.question:hover').data('key');
            // get question model from collection

            var question = this.collection.findWhere({question_key: question_key});

            if (!question) {
                return;
            }

            this.trigger('Question:Duplicate', question);
        },

        onChange: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var question_change = new View_Question_Select({
                mode: 'change',
                collection: this.collection
            });

            Modal.open({
                width: 500,
                title: 'Change question type',
                content: question_change,
                onClosed: () => {
                    question_change.remove();
                }
            });

            question_change.on('Question:Change', (question_type, question_sub_type) => {
                this.trigger('Question:Change', question_type, question_sub_type);

                Modal.close();
            });
        },

        onMouseLeave: function(e) {
            this.$el.find('.button-dropdown > div').hide();
        },


        onDocumentClick: function(e) {
            var clicked_element = $(e.target);

            // hide the question add region if the clicked element is not the add button or the disabled question
            if (!clicked_element.hasClass('question-add') &&
                !(clicked_element.parent().hasClass('survey-question-select') && clicked_element.hasClass('disabled')) &&
                !clicked_element.hasClass('stop-propagation')
            ) {
                this.$el.find('.region-questions-add').hide();
                this.$el.find('.region-questions-change').hide();
            }
        }
    },

    event_handlers: {
        onQuestionsAdd: function(type, sub_type) {
            this.trigger('Question:Add', type, sub_type);
        },

        onQuestionChange: function(type, sub_type) {
            this.trigger('Question:Change', type, sub_type);
        },

        onQuestionLabelChange: function(model) {
            // update the question label
            var placeholder = 'Type your question here...';
            var question_label = model.get('question_label') ? model.escape('question_label') : placeholder;

            this.$el.find('.question[data-key="' + model.get('question_key') + '"] .question-label').html(question_label);
        },
        onQuestionTypeChange: function(model) {
            this.render();

            // build setting view
            this.buildSettingView();
        }
    },

    initialize: function(options) {
        this.survey = options.survey;

        this.listenTo(this.collection, 'add',    this.render);
        this.listenTo(this.collection, 'remove', this.render);
        this.listenTo(this.collection, 'change:question_type',  this.event_handlers.onQuestionTypeChange);
        this.listenTo(this.collection, 'change:question_label', this.event_handlers.onQuestionLabelChange);
        this.listenTo(this.collection, 'reset',  this.render);

        $(document).on('click.survey_question_list', this.dom_handlers.onDocumentClick.bind(this));

        this.on('remove', () => {
            $(document).off('click.survey_question_list');
        });
    },

    buildSettingView: function() {
        if (!this.selected_question) {
            return;
        }

        if (this.views.question_settings instanceof View_Question_Settings) {
            this.views.question_settings.remove();
        }

        this.views.question_settings = new View_Question_Settings({
            model: this.selected_question,
            survey: this.survey
        });

        this.views.question_settings.render().$el.appendTo(this.$el.find('.question.active .region-question-settings'));
    },

    openSettings: function(question_model) {
        var question_key = question_model.get('question_key');
        this.selected_question = this.collection.findWhere({question_key: question_key});

        // active question
        this.$el.find('.question').removeClass('active');
        this.$el.find('.question[data-key="' + question_key + '"]').addClass('active');

        this.buildSettingView();
    },

    renderQuestions: function() {
        var content = '';

        var questions = this.collection.filter((model) => {
            var question_type = model.get('question_type');
            return question_type !== 'thankyou' && question_type !== 'welcome';
        });

        questions.forEach((model) => {
            content += this.renderQuestion(model);
        });

        return content;
    },

    renderWelcome: function() {
        var content = '';
        var welcome = this.collection.findWhere({question_type: 'welcome'});

        if (welcome) {
            content += this.renderQuestion(welcome);
        }

        return content;
    },

    renderThankyou: function() {
        var content = '';
        var thank_you = this.collection.findWhere({question_type: 'thankyou'});

        if (thank_you) {
            content += this.renderQuestion(thank_you);
        }

        return content;
    },

    renderQuestion: function(model) {
        var data_type;
        var placeholder = 'Type your question here...';

        switch (model.get('question_type')) {
            case 'welcome':
                data_type = 'welcome';
                placeholder = 'Type your text here...';
                break;
            case 'dropdown':
                data_type = 'selection';
                break;
            case 'yesno':
                data_type = 'selection';
                break;
            case 'multiple':
                data_type = 'selection';
                break;
            case 'nps':
                data_type = 'poll';
                break;
            case 'rating':
                if (model.get('question_sub_type') === 'star') {
                    data_type = 'poll';
                } else if (model.get('question_sub_type') === 'face') {
                    data_type = 'poll';
                } else if (model.get('question_sub_type') === 'number') {
                    data_type = 'poll';
                } else if (model.get('question_sub_type') === 'heart') {
                    data_type = 'poll';
                } else if (model.get('question_sub_type') === 'thumb') {
                    data_type = 'poll';
                } else {
                    data_type = 'poll';
                }
                break;
            case 'long':
                data_type = 'text';
                break;
            case 'short':
                data_type = 'text';
                break;
            case 'thankyou':
                data_type = 'thankyou';
                break;
        }

        // Can't delete when there is only one question(exclude thankyou question) left.
        var can_delete = this.collection.filter((item) => {
            return item.get('question_type') !== 'thankyou';
        }).length >= 2;
        var is_welcome = model.get('question_type') === 'welcome';
        var is_thankyou = model.get('question_type') === 'thankyou';

        var dropdown_content =
            (is_welcome || is_thankyou ? '' :
            '<li class="duplicate stop-propagation">Duplicate</li>') +

            (is_welcome || is_thankyou || this.survey.get('first_active_time') > 0 ? '' :
            '<li class="change stop-propagation">Change</li>') +

            (can_delete && !is_welcome && !is_thankyou ?
            '<li class="separator"></li>' : '') +

            (can_delete ?
            '<li class="delete">Remove</li>' : '');

        var is_selected_question = this.selected_question && model.get('id') === this.selected_question.get('id');

        return '' +
        '<div class="question ' + (is_selected_question ? 'active' : '') + '" data-type="' + data_type + '" data-id="' + model.get('id') + '" data-key="' + model.get('question_key') + '">' +
            '<div class="question-header">' +
                '<div class="question-name">' + model.getName() + '</div>' +
                '<div class="question-label">'+ (model.get('question_label') ? model.escape('question_label') : placeholder) +'</div>' +
                (is_welcome || is_thankyou ? '' :
                '<div class="drag-handle stop-propagation">' +
                    '<i class="fas fa-grip-dots-vertical"></i>' +
                '</div>') +
                (dropdown_content !== '' && !is_thankyou ?
                '<div class="menu-button button-dropdown">' +
                    '<button type="button" class="ellipsis stop-propagation"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                            dropdown_content +
                        '</ul>' +
                    '</div>' +
                '</div>' : '') +
            '</div>' +
            '<div class="region-question-settings"></div>' +
        '</div>';
    },

    sortable: function() {
        new Sortable(this.$el.find('.sortable-container-main').get(0), {
            ghostClass: 'drag-placeholder',
            handle: '.drag-handle',
            animation: 200,
            onStart: () => {
                this.$el.find('.question').addClass('drag-start');
            },
            onEnd: () => {
                this.$el.find('.question').removeClass('drag-start');
            },
            onSort: (evt) => {
                this.updateQuestionSort();
            }
        });
    },

    updateQuestionSort: function() {
        // has welcome page
        this.$el.find('.question').each((index, el) => {
            var question_key = $(el).data('key');

            // get question data from collection by id
            var question = this.collection.findWhere({question_key: question_key});

            question.set('question_sort', index + 1);
        });

        this.collection.sort();
    },

    createQuestionAdd: function() {
        if (this.views.question_add instanceof View_Question_Select) {
            this.views.question_add.remove();
        }

        this.views.question_add = new View_Question_Select({
            mode: 'add',
            collection: this.collection
        });

        this.views.question_add.render().$el.appendTo(this.$el.find('.region-questions-add'));

        this.listenTo(this.views.question_add, 'Question:Add', this.event_handlers.onQuestionsAdd);
    },

    render: function() {
        var content =
        '<div>' +
            this.renderWelcome() +
            '<div class="sortable-container-main">' +
                this.renderQuestions() +
            '</div>' +
        '</div>' +

        '<div class="divider-16"></div>' +

        '<button type="button" class="question-add tertiary small min">Add</button>' +
        '<div class="region-questions-add"></div>' +

        '<div class="region-questions-change"></div>' +

        '<div class="divider-24"></div>' +

        '<div class="region-ending">' +
            '<span>Ends with</span>' +
        '</div>' +
        '<div>' +
            this.renderThankyou() +
        '</div>';

        this.$el.html(content);

        this.createQuestionAdd();

        this.sortable();

        return this;
    }
});
